<template>
  <div class="project">
    <advertising-figure />
    <div class="inner-page-nav">
      <inner-page-nav />
    </div>
    <div class="inner-page-content">
      <public-title :title="title">
        <span class="sub">Inform of the meeting</span>
      </public-title>

      <div class="divider">
        <h2 class="tit">会议通知</h2>
        <span class="time"
          >发布日期:
          {{ simpleDateFormat(inform.create_time) }}</span
        >
      </div>

      <div class="meet-detail-wrap">
        <h2 class="tit">{{ inform.name }}</h2>
        <div
          class="meet-item"
          v-if="inform.file_metadata && inform.file_metadata.length > 0"
          style="margin-left:4px;"
        >
          <span>点击文件名下载附件：</span>
          <a
            style="font-size: 16px; font-weight: bold;color:#666;"
            :href="inform.file_metadata[0].url"
          >
            {{ inform.file_metadata[0].filename }}
          </a>
        </div>
        <span
          class="meet-item"
          v-if="
            inform.file_metadata &&
            inform.file_metadata.length > 0 &&
            this.inform.content.length > 0
          "
          style="margin-left:4px;"
          >正文：</span
        >
        <div class="meet-detail">
          <RichHtml :content="this.inform.content"></RichHtml>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AdvertisingFigure from "@components/advertising"
  import InnerPageNav from "@components/tool-nav"
  import publicTitle from "@components/title"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import RichHtml from "@/components/RichHtml"
  import { ConfInform } from "@/store/entity/conferinfo"

  export default {
    name: "MeetDetailPage",
    components: {
      AdvertisingFigure,
      InnerPageNav,
      publicTitle,
      RichHtml,
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        title: "会议通知",
        inform: {},
      }
    },
    async created() {
      if (this.$route.params.inform) {
        this.inform = this.$route.params.inform
      } else if (this.$route.query.inform_id) {
        this.inform = await ConfInform.get_by_id(this.$route.query.inform_id)
      }
    },

    methods: {
      openfile() {
        const url = this.inform.file_metadata[0].url
        window.open(url)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@assets/scss/innerpagenav.scss";

  .inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
  }

  .inner-page-content {
    margin: 60px 0;
  }

  .divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
      position: relative;
      font-size: 18px;
      color: #666;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 30px;
        height: 2px;
        background: $defaultColor;
      }
    }

    .time {
      font-size: 14px;
      color: #999;
    }
  }

  .meet-detail-wrap {
    width: 1200px;
    margin: 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .meet-detail {
      width: 100%;
      padding: 30px;
    }

    .tit {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: inline-block;
      min-width: 180px;
      font-size: 20px;
      margin: 30px 0;
      color: $defaultColor;
      padding: 0 30px;
      text-align: center;

      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: -100px;
        width: 100px;
        height: 2px;
        background: linear-gradient(to right, transparent, #ccc);
      }

      &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: -100px;
        width: 100px;
        height: 2px;
        background: linear-gradient(to left, transparent, #ccc);
      }
    }

    .meet-item {
      font-size: 14px;
      color: #666;
      margin-bottom: 15px;
      line-height: 30px;

      .small-tit {
        color: $defaultColor;
      }
    }
    .small-tit1 {
      margin-left: 100px;
      color: $defaultColor;
    }
  }
</style>
